<div class="sitewrapper">
    <h2>The software features you need:</h2>

    <div class="row">
        <div *ngFor="let f of features" class="col-md-4 col-12">
            <div class="card">
                <div class="card-body">
                    <img [alt]="f.title" [src]="f.imageString"/>
                    <div class="title">{{f.title}}</div>
                </div>
            </div>
        </div>
    </div>
</div>

